import { createTableRow } from './createTableRow';
import type {
    ContentModelTable,
    ContentModelTableFormat,
    ContentModelTableRow,
} from 'roosterjs-content-model-types';

/**
 * Create a ContentModelTable model
 * @param rowCount Count of rows of this table
 * @param format @optional The format of this model
 */
export function createTable(
    rowCount: number,
    format?: Readonly<ContentModelTableFormat>
): ContentModelTable {
    const rows: ContentModelTableRow[] = [];

    for (let i = 0; i < rowCount; i++) {
        rows.push(createTableRow());
    }

    return {
        blockType: 'Table',
        rows,
        format: { ...format },
        widths: [],
        dataset: {},
    };
}
